import { render, staticRenderFns } from "./showMyIdea.vue?vue&type=template&id=0f53665c"
import script from "./showMyIdea.vue?vue&type=script&lang=js"
export * from "./showMyIdea.vue?vue&type=script&lang=js"
import style0 from "./showMyIdea.vue?vue&type=style&index=0&id=0f53665c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports